import React, { FC, useEffect } from "react";
import { MatterEditorContainer } from "../../containers/matter-editor-container";
import { useParams } from "react-router";
import { AccessControl } from "../../components/auth";
import { Permission, useCurrentUserData } from "../../hooks";
import { Userpilot } from "userpilot";

export const MatterEditor: FC = () => {
  const { matterId } = useParams();

  const currentLoggedInUser = useCurrentUserData({ cache: true });

  useEffect(() => {
    Userpilot.identify(currentLoggedInUser?.currentUser?.userId.toString() || "", {
      matterId,
    });
  }, []);

  return (
    <AccessControl permissions={[Permission.READ_MATTER, Permission.UPDATE_MATTER]}>
      <MatterEditorContainer matterId={Number.parseInt(matterId || "")} />
    </AccessControl>
  );
};
